module.exports = __webpack_public_path__ + "img/google_authenticator.24521121.png";